export default {
  "en": {
    "session": {
      "error_internalserver": {
        "goback": "Go back",
        "subtitle": "Oops, an unexpected error seems to have occurred.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Go back",
        "subtitle": "Sorry, the page you are looking for could not be found.",
        "title": "404"
      },
      "expired": {
        "text": "Your session has expired due to inactivity. For security reasons, you are required to login again. \n\nClick OK to be redirected to the login screen.",
        "title": "Session Expired"
      },
      "logout_impersonate": {
        "text": "A logout action has been triggered during impersonation.",
        "title": "Impersonation stopped"
      },
      "noaccess": {
        "text": "You currently do not have access to this page, you will be redirected back to the home page.",
        "title": "Access denied for '{hostname}'"
      }
    }
  }
}